import { Outlet, useLocation } from 'react-router-dom'

import { ErrorBoundary } from '@/components/ErrorBoundary'
import { StepbarWrapper } from '@/components/StepbarWrapper'
import { AppHeader } from '@/components/AppHeader'
import { Contentwrapper } from '@/components/ContentWrapper'
import { Chat } from '@/components/Chat'
import { Loading } from '@/components/Loading'
import { StepBar } from '@/components/StepBar'
import { NavigationGuard } from '@/components/NavigationGuard'
import { FeatureFlagsApCore } from '@/components/FeatureFlagsApCore'
import { DebugLogsOverlay } from '@/components/DebugLogsOverlay'

export function RootLayout() {
  const { pathname } = useLocation()

  return (
    <Contentwrapper>
      <FeatureFlagsApCore>
        <header className="header-wrapper">
          <AppHeader />
        </header>
      </FeatureFlagsApCore>

      <main>
        <StepbarWrapper>
          <StepBar />
        </StepbarWrapper>
        <div className="content-wrapper">
          <NavigationGuard>
            <ErrorBoundary key={pathname}>
              <Outlet />
            </ErrorBoundary>
          </NavigationGuard>
        </div>
        <Chat />
        <Loading />
      </main>
      <DebugLogsOverlay />
    </Contentwrapper>
  )
}
